// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2l89p","label":"Category_label__FRyab","content":"Category_content__1ppC_","header":"Category_header__2CtvY","location":"Category_location__1qWon"};